export default "__VITE_ASSET__Br3bygBK__"